import { createColumnHelper } from '@tanstack/react-table';
import { RowData } from '@tanstack/table-core';

import { ColumnTypesInternal } from 'support/types/webediTable';

import { SelectionCell } from '../cells/SelectionCell';

export const selectionPartial = <TData extends RowData>(columnHelper: ReturnType<typeof createColumnHelper<TData>>) =>
  columnHelper.display({
    id: ColumnTypesInternal.procuros_select,
    meta: {
      type: ColumnTypesInternal.procuros_select,
    },
    header: ({ table }) => {
      const isSubmitting = table.options.meta?.isSubmitting ?? false;
      return (
        <SelectionCell
          checked={table.getIsAllRowsSelected()}
          onChange={table.getToggleAllRowsSelectedHandler()}
          indeterminate={table.getIsSomeRowsSelected()}
          disabled={isSubmitting}
        />
      );
    },
    cell: ({ row, table }) => {
      const isSubmitting = table.options.meta?.isSubmitting ?? false;
      return (
        <SelectionCell
          checked={row.getIsSelected()}
          disabled={isSubmitting || !row.getCanSelect()}
          onChange={row.getToggleSelectedHandler()}
        />
      );
    },
  });
